import { createReducer, on } from '@ngrx/store';
import { initialLpsState } from './lps.state';
import { LpsActions } from './lps.actions';

export const lpsReducer = createReducer(
    initialLpsState,

    // Dashboard
    on(LpsActions.loadDashboard, (state) => ({
        ...state,
        loading: true,
        errorMessage: null
    })),
    on(LpsActions.loadDashboardSuccess, (state, action) => ({
        ...state,
        activities: action.activities,
        constraints: action.constraints,
        weeklyPlan: action.weeklyPlan,
        ppc: action.ppc,
        milestones: action.milestones,
        loading: false,
        errorMessage: null
    })),
    on(LpsActions.loadDashboardFail, (state, action) => ({
        ...state,
        loading: false,
        errorMessage: action.error
    })),

    // Activities
    on(LpsActions.loadActivitiesSuccess, (state, action) => ({
        ...state,
        activities: action.activities,
        loading: false
    })),
    on(LpsActions.createActivitySuccess, (state, action) => ({
        ...state,
        activities: [...state.activities, action.activity]
    })),
    on(LpsActions.updateActivitySuccess, (state, action) => ({
        ...state,
        activities: state.activities.map(a =>
            a.lpsActivityId === action.activity.lpsActivityId ? action.activity : a
        )
    })),

    // Constraints
    on(LpsActions.loadConstraintsSuccess, (state, action) => ({
        ...state,
        constraints: action.constraints,
        loading: false
    })),
    on(LpsActions.addConstraintSuccess, (state, action) => ({
        ...state,
        constraints: [...state.constraints, action.constraint]
    })),
    on(LpsActions.releaseConstraintSuccess, (state, action) => ({
        ...state,
        constraints: state.constraints.map(c =>
            c.lpsConstraintId === action.constraint.lpsConstraintId ? action.constraint : c
        )
    })),

    // Weekly Plan
    on(LpsActions.loadWeeklyPlanSuccess, (state, action) => ({
        ...state,
        weeklyPlan: action.weeklyPlan,
        loading: false
    })),
    on(LpsActions.commitActivitySuccess, (state) => ({
        ...state
    })),

    // Metrics
    on(LpsActions.loadPpcSuccess, (state, action) => ({
        ...state,
        ppc: action.ppc
    })),
    on(LpsActions.loadCncAnalysisSuccess, (state, action) => ({
        ...state,
        cncAnalysis: action.cncAnalysis
    })),

    // Milestones
    on(LpsActions.loadMilestonesSuccess, (state, action) => ({
        ...state,
        milestones: action.milestones
    })),

    // Clear
    on(LpsActions.clearLps, () => initialLpsState)
);
